<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { getLogin } from "@/services/auth";
import ReCaptcha from '@/components/ReCaptcha.vue';

const router = useRouter();
const RECAPTCHA_SITE_KEY = '6LeYVXotAAAAAEpLJ74bmwlfvVoFuZ41xvOlkGzH';

const email = ref("");
const password = ref("");
const errorMessage = ref(null);
const recaptchaToken = ref('');
const recaptchaError = ref('');
const isSubmitting = ref(false);
const recaptchaRef = ref(null);

const handleRecaptchaVerify = (token) => {
  recaptchaToken.value = token;
  recaptchaError.value = '';
};

const handleRecaptchaError = (error) => {
  recaptchaError.value = 'Error al verificar reCAPTCHA. Por favor, intente nuevamente.';
  console.error('reCAPTCHA error:', error);
  isSubmitting.value = false;
};

const login = async () => {
  if (isSubmitting.value) return;
  
  try {
    isSubmitting.value = true;
    errorMessage.value = null;
    recaptchaError.value = null;

    // Ejecutar reCAPTCHA justo antes de enviar
    await recaptchaRef.value.executeRecaptcha();

    if (!recaptchaToken.value) {
      recaptchaError.value = 'Por favor, complete la verificación de seguridad.';
      isSubmitting.value = false;
      return;
    }

    const structureObject = {
      email: email.value,
      password: password.value,
      recaptchaToken: recaptchaToken.value
    };

    const response = await getLogin(structureObject);
    console.log("Respuesta del servidor:", response.data);
    
    if (response.data && response.data.authToken) {
      // Inicio de sesión exitoso
      localStorage.setItem("authToken", response.data.authToken);
      localStorage.setItem("a", response.data.isAdmin);
      localStorage.setItem("r", response.data.role);
      localStorage.setItem("cx", response.data.clients_id);
      router.push("/dashboard");
    } else if (response.data && response.data.message) {
      // Inicio de sesión fallido
      errorMessage.value = "Usuario y/o contraseña incorrectos";
    } else {
      // Respuesta desconocida
      errorMessage.value = "Error desconocido al iniciar sesión.";
    }
  } catch (err) {
    if (err.message.includes('Verificación de reCAPTCHA')) {
      recaptchaError.value = 'La verificación de seguridad falló. Por favor, intente nuevamente.';
    } else {
      errorMessage.value = "Error al iniciar sesión. Por favor, inténtalo de nuevo más tarde.";
    }
    console.error("Error:", err);
  } finally {
    isSubmitting.value = false;
  }
};
</script>
<template>
  <article class="global-container login">
    <div class="login-card">
      <div class="card-body">
        <h6 class="login-pre-title">Bienvenido a</h6>
        <h5 class="login-title">Golden Contactability</h5>
        <p class="login-sub-title">Inicia sesión para comenzar.</p>
        <form @submit.prevent="login">
          <div class="mb-3">
            <label for="exampleInputEmail1" class="form-label">Email</label>
            <input
              type="email"
              class="form-control login-input"
              id="exampleInputEmail1"
              v-model="email"
              :disabled="isSubmitting"
            />
          </div>
          <div class="mb-3">
            <label for="exampleInputPassword1" class="form-label"
              >Password</label
            >
            <input
              type="password"
              class="form-control login-input"
              id="exampleInputPassword1"
              v-model="password"
              :disabled="isSubmitting"
            />
          </div>
          <div class="mb-3 form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="exampleCheck1"
            />
            <label class="form-check-label" for="exampleCheck1"
              >Recordarme Siempre</label
            >
          </div>

          <div v-if="errorMessage" class="error-message text-danger">
            {{ errorMessage }}
          </div>

          <div class="recaptcha-container">
            <ReCaptcha
              ref="recaptchaRef"
              :site-key="RECAPTCHA_SITE_KEY"
              action="login"
              @verify="handleRecaptchaVerify"
              @error="handleRecaptchaError"
              :disabled="isSubmitting"
            />
            <div v-if="recaptchaError" class="error-message">
              {{ recaptchaError }}
            </div>
          </div>

          <span
            style="display: flex; justify-content: center; margin-bottom: 15px"
          >
            <a href="/forgot-password" class="login-a">
              Olvidé mi contraseña
            </a>
          </span>
          <div class="d-flex justify-content-center">
            <button 
              type="submit" 
              class="btn login-button"
              :disabled="isSubmitting"
            >
              {{ isSubmitting ? 'Iniciando sesión...' : 'Iniciar sesión' }}
            </button>
          </div>
        </form>
        <!-- <div class="d-flex flex-column gap-2 text-center mt-3">
                <p class="m-0" style="font-size: small;">¿No estás registrado?</p>
                <div class="w-auto">
                    <a href="" class="login-a">Regístrate para crear una cuenta</a>
                </div>
            </div> -->
      </div>
    </div>
  </article>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.error-message {
  text-align: center;
  color: $error2-color;
  margin: 5px 0;
}

.recaptcha-container {
  margin: 1rem 0;
  min-height: 50px;
}
</style>
